<div class="saved_chat_wrapper" 
[class.saved_selected_chat]="d?.id === selectedChatId" 
*ngFor="let d of data;" 
(click)="onClickChatEvent(d)">
  <div>
    {{d?.title | capitalize}}
  </div>
</div>
